export var CostType;
(function (CostType) {
    CostType["Parking"] = "parking";
    CostType["Storage"] = "storage";
    CostType["Garage"] = "garage";
    CostType["Komorka"] = "komorka";
    CostType["MiejscePostojowe"] = "miejsce-postojowe";
    CostType["Commission"] = "commission";
    CostType["Other"] = "other";
    CostType["UsageRights"] = "usage_rights";
})(CostType || (CostType = {}));
export var CostCategory;
(function (CostCategory) {
    CostCategory["RelatedRooms"] = "related_rooms";
    CostCategory["UsageRights"] = "usage_rights";
    CostCategory["OtherServices"] = "other_services";
})(CostCategory || (CostCategory = {}));
export const CATEGORY_MAP = {
    [CostType.Parking]: CostCategory.RelatedRooms,
    [CostType.Storage]: CostCategory.RelatedRooms,
    [CostType.Garage]: CostCategory.RelatedRooms,
    [CostType.Komorka]: CostCategory.OtherServices,
    [CostType.MiejscePostojowe]: CostCategory.RelatedRooms,
    [CostType.UsageRights]: CostCategory.UsageRights,
    [CostType.Commission]: CostCategory.OtherServices,
    [CostType.Other]: CostCategory.OtherServices,
};
export const COST_TYPE_LABELS = {
    [CostType.Parking]: 'Miejsce parkingowe',
    [CostType.Storage]: 'Komórka',
    [CostType.Garage]: 'Garaż',
    [CostType.Komorka]: 'Komórka',
    [CostType.MiejscePostojowe]: 'Miejsce postojowe',
    [CostType.Commission]: 'Prowizja',
    [CostType.Other]: 'Inne',
    [CostType.UsageRights]: 'Prawa do korzystania',
};
export function costTypesByCategory(category) {
    return Object.entries(CATEGORY_MAP)
        .filter(([, cat]) => cat === category)
        .map(([type]) => type);
}
export class AdditionalCost {
    constructor(data) {
        this.id = data.id;
        this.propertyId = data.propertyId;
        this.costType = data.costType;
        this.description = data.description;
        this.amount = data.amount;
        this.validFrom = data.validFrom;
        this.isOptional = data.isOptional;
        this.isIncludedInPrice = data.isIncludedInPrice;
    }
    get isMandatory() {
        return !this.isOptional && !this.isIncludedInPrice;
    }
    get category() {
        return CATEGORY_MAP[this.costType];
    }
    get displayName() {
        return COST_TYPE_LABELS[this.costType];
    }
}
//# sourceMappingURL=additional-cost.js.map